module.exports = __webpack_public_path__ + "static/img/icon-01.f2e0bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works/icon-01.png
// module id = ZJ7F
// module chunks = 1